import { TravelExpenses } from '@work4all/models/lib/Classes/TravelExpenses.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/travelExpenses-table-schema.json';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

export function TravelExpensesTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<TravelExpenses, never>({
    ...props,
    schema: schema as never,
    defaultSort,
  });
  return <EntityTableV8 {...props} {...dataTable} />;
}
